import { Fraction } from '../realty/model/Fraction';
import { Person } from '../realty/model/Person';
import { ApiDate } from '../realty/model/ApiDate';

export class Ownership {
  public name: string;
  public fraction: Fraction;
  public dateRegistered: ApiDate;

  public constructor(owningPerson: Person, dateRegistered: ApiDate, fraction: Fraction) {
    this.dateRegistered = dateRegistered;
    this.name = owningPerson.name;
    this.fraction = fraction;
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Ownership.ts
 **/